import { useState } from 'react';
import { Modal } from '../../../../core/components/templates/Modal';
import { ILesson, IMaterial, IPodcasts } from '../../../../core/models/disciplines';
import { IExercise } from '../../../../core/models/exercise';
import { Typography } from '../../../../core/components/molecules/Typography';
import { Button } from '../../../../core/components/atoms/Button';
import { Icon } from '../../../../core/components/atoms/Icon';
import { useSubjectStore } from '../../stores/subjectStore';
import { useNewSubjectStore } from '../../stores/newSubjectStore';
import MultipleSelect from '../../../../core/components/atoms/MultipleSelect';
import ContentModalLesson from './components/Lesson';
import ContentModalExercise from './components/Exercise';
import ContentModalMaterial from './components/Material';
import FilterTagsList from '../FilterTagsList';
import AnotherContentFilter from '../ModalFilter/Content/outros';
import ExerciseContentFilter from '../ModalFilter/Content/exercicios';
import { useDisciplinesAuxStore } from '../../stores/auxStore';

type Content = IMaterial[] | ILesson[] | IExercise[] | IPodcasts[] | null;

interface IContentModal {
  isOpen: boolean;
  onClose: () => void;
  slug: string;
  subtitle: string;
  discipline: string;
  module: string;
  subject: string;
  initialTab: number;
  initialContent: Content;
  contentType: string;
}

function ContentModal({
  isOpen,
  onClose,
  subtitle,
  subject,
  contentType
}: IContentModal) {
  const { subjects } = useSubjectStore();
  const subjectObject = subjects?.find((sbj) => sbj.slug === subject);
  const title = subjectObject ? subjectObject.title : subject;

  const { setSelectedSubjects, selectedSubjects, selectOptions } = useNewSubjectStore();
  const { playlistResultNumber } = useDisciplinesAuxStore()
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const showContent = () => {
    if(contentType === "videoaula") {
      return <ContentModalLesson onClose={() => onClose()}/>
    }

    if(contentType === "exercicio") {
      return <ContentModalExercise onClose={() => onClose()} />
    }

    if(contentType === "materiais") {
      return <ContentModalMaterial onClose={() => onClose()} />
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      position='top-right'
      title={title}
      subtitle={subtitle}
      className={`
        font-noto
        relative
        m-0 
        mt-[10vh] 
        flex  
        min-h-[90vh]

        max-w-full
        
        flex-col
        rounded-b-lg 
        bg-color-modal-conteudo
        md:m-4
        md:min-h-[calc(100%-2rem)]
        md:max-w-lg
        md:rounded-b-lg   
      `}
    >
      <MultipleSelect
        label='Selecione os assuntos'
        options={selectOptions}
        selected={selectedSubjects}
        onChange={(value) => setSelectedSubjects(value)}
      />

      <div className='mt-5 mb-2'>
        <div className='flex flex-row justify-between items-center'>
          <Typography>
            {playlistResultNumber} Resultados
          </Typography>
          <Button
            variant='text'
            onClick={() => setIsFilterOpen((prev) => !prev)}
            aria-expanded={isFilterOpen}
          >
            <Icon
              Icon='filter_list'
              type='material'
              className='xs:text-sm md:text-md'
            />
            <span className='xs:text-sm md:text-md'>
              {contentType === 'videoaula' && 'Filtrar videoaulas'}
              {contentType === 'exercicio' && 'Filtrar exercícios'}
              {contentType === 'materiais' && 'Filtrar materiais'}
            </span>
            <Icon
              Icon='expand_more'
              type='material'
              className={`xs:text-sm md:text-md transition-transform ${isFilterOpen ? 'rotate-180' : ''}`}
            />
          </Button>
        </div>

        {isFilterOpen && (
          <div className='mt-2 max-h-[42vh] overflow-y-auto rounded-md border-hairline border-mono-color-lighter bg-mono-color-white p-3 shadow-level-1'>
            {contentType !== "exercicio" && <AnotherContentFilter contentType={contentType} compact />}
            {contentType === "exercicio" && <ExerciseContentFilter compact />}
          </div>
        )}
      </div>

      <FilterTagsList />

      <div className='flex flex-col gap-lg mt-5'>
        {showContent()}
      </div>
    </Modal>
  );
}

export default ContentModal;
